import Navbar from '../home/components/Navbar';
import Hero from './components/Hero';
import Content from './components/Content';
import FAQ from './components/FAQ';
import Footer from '../home/components/Footer';
import { useSchemaOrg, usePageMeta } from '../../utils/seo';

export default function PianoRemovalCostLondon() {
  // Set page meta tags
  usePageMeta(
    'Piano Removal Cost London 2026 | Upright £149 | Grand £320',
    'Complete 2026 price guide for piano removal in London. Upright from £149, baby grand from £320, concert grand from £550. No hidden fees. Free fixed quote — 020 3441 9463.',
    'piano removal cost London, piano moving prices London, piano removal prices, piano movers cost London',
    'https://www.pianomovers.co.uk/piano-removal-cost-london',
    'Piano Removal Cost London 2026 | Upright £149 | Grand £320',
    'Complete 2026 price guide for piano removal London. Upright from £149, baby grand from £320, concert grand from £550. No hidden fees. Free quote — 020 3441 9463.',
    'Piano Removal Cost London 2026 | From £149',
    'Full 2026 piano removal price guide. Upright from £149, grand from £320. No hidden fees. Free quote — 020 3441 9463.'
  );

  useSchemaOrg({
    type: 'FAQPage',
    data: {
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Why is piano removal more expensive than normal furniture removal?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Piano removal costs more because pianos are precision musical instruments requiring specialist handling, not just heavy furniture. Professional piano movers invest in purpose-built equipment including piano boards, heavy-duty straps rated for 600kg, protective blankets, and stair-climbing systems that standard removal companies don\'t possess. Their teams receive extensive training in weight distribution, shock absorption, and protecting delicate internal mechanisms. Additionally, specialist piano movers carry comprehensive insurance up to £5 million specifically covering musical instruments, whereas standard removers typically exclude pianos or have inadequate coverage.',
          },
        },
        {
          '@type': 'Question',
          name: 'Does piano removal cost include insurance in London?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Reputable piano removal companies in London include comprehensive goods-in-transit insurance as standard within their quoted prices. This insurance typically covers up to £5 million for damage to your piano during the move. However, you should always confirm insurance coverage details before booking, as some budget operators may offer lower coverage or charge extra for full protection. Request written confirmation of insurance levels and ensure the policy specifically covers pianos, not just general household goods.',
          },
        },
        {
          '@type': 'Question',
          name: 'Can I get a same-day piano removal in London?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Same-day piano removal in London is occasionally possible for urgent situations, but availability depends on the company\'s schedule and your location. Most specialist piano movers require 2-3 days notice for weekday moves and 1-2 weeks for weekend bookings. Same-day service typically incurs a premium charge of 30-50% above standard rates. For best availability and pricing, book your piano removal at least one week in advance, particularly during busy periods like end of month or summer holidays.',
          },
        },
      ],
    },
  });

  useSchemaOrg({
    type: 'WebPage',
    data: {
      '@type': 'Service',
      name: 'Piano Removal Service London',
      provider: {
        '@type': 'LocalBusiness',
        name: 'Piano Movers UK',
      },
      offers: {
        '@type': 'Offer',
        priceSpecification: {
          '@type': 'PriceSpecification',
          price: '149',
          priceCurrency: 'GBP',
          description: 'Upright piano removal starting price',
        },
      },
    },
  });

  return (
    <div className="bg-[#f5f5f0] text-[#1a1916]">
      <Navbar />
      <Hero />
      <Content />
      <FAQ />
      <div className="bg-[#1a1916] py-4 text-center">
        <p className="text-[#d4d4ce] text-xs">
          Piano Movers UK is an independent guide to piano removal services in London.
        </p>
      </div>
      <Footer />
    </div>
  );
}